export const OTA_STEP_STATUS = {
  COMPLETED: 'OTA_STEP_STATUS_COMPLETED',
  FAILED: 'OTA_STEP_STATUS_FAILED',
  IN_PROGRESS: 'OTA_STEP_STATUS_IN_PROGRESS',
  PENDING: 'OTA_STEP_STATUS_PENDING',
  UNSPECIFIED: 'OTA_STEP_STATUS_UNSPECIFIED',
} as const;

export type OtaStepStatus =
  (typeof OTA_STEP_STATUS)[keyof typeof OTA_STEP_STATUS];

export const OTA_EXECUTION_STATUS = {
  CANCELLED: 'OTA_EXECUTION_STATUS_CANCELLED',
  COMPLETED: 'OTA_EXECUTION_STATUS_COMPLETED',
  FAILED: 'OTA_EXECUTION_STATUS_FAILED',
  IN_PROGRESS: 'OTA_EXECUTION_STATUS_IN_PROGRESS',
  UNSPECIFIED: 'OTA_EXECUTION_STATUS_UNSPECIFIED',
} as const;

export type OtaExecutionStatus =
  (typeof OTA_EXECUTION_STATUS)[keyof typeof OTA_EXECUTION_STATUS];

export const OTA_STEP_NAME = {
  START: 'OTA_STEP_START',
  CORTEX: 'OTA_STEP_CORTEX',
  MINUS: 'OTA_STEP_MINUS',
  UPDATE: 'OTA_STEP_UPDATE',
  END: 'OTA_STEP_END',
} as const;
